const templateUrl = require('./expiration-date.html');

module.exports = angular.module('msi.payments.form.expiration-date', [
  require('./not-expired-validator')
]).name;

angular.module(module.exports)
  .component('ogExpirationDateControl', {
    templateUrl: templateUrl,
    controller: require('./expiration-date.controller'),
    require: {
      'ngModel': 'ngModel',
      'form': '^^form'
    },
    bindings: {
      model: '=ngModel',
      requiredFields: '<ogRequiredFields',
      disabledFields: '<ogDisabledFields'
    }
  });
